<div class="app-payment-modal" [dir]="direction">
  <app-modal-controls [showBack]="showBack$ | async" (backClicked)="prevStep()"> </app-modal-controls>
  <ng-container>
    <div class="app-payment-modal-content">
      @switch (paymentStatus$ | async) { @case (PaymentStatus.CREATED) {
      <app-payment-confirm [paymentStatus]="PaymentStatus.CREATED"></app-payment-confirm>
      } @case (PaymentStatus.VALIDATING_ADDRESS) {
      <app-payment-confirm [paymentStatus]="PaymentStatus.VALIDATING_ADDRESS"></app-payment-confirm>
      } @case (PaymentStatus.COMPLETED) {
      <app-payment-has-been-sent></app-payment-has-been-sent>
      } @case (PaymentStatus.INITIATED) {
      <app-payment-has-been-saved></app-payment-has-been-saved>
      } @default { @switch (payment?.operationType) { @case (PaymentType.CURRENCY_EXCHANGE) {
      <app-currency-exchange [payerAccount]="payment.payerAccount"></app-currency-exchange>
      } @default {
      <app-bank-transfer [payment]="payment"></app-bank-transfer>
      } } } }
    </div>
  </ng-container>
</div>
